import { useQuery } from '@tanstack/react-query';
import { fetchAuthSession } from 'aws-amplify/auth';
import { CognitoUser } from 'schemas/UserInfo.schema.ts';
import { apiFetch } from 'utils/apiUtils';

export type Role =
  | 'read'
  | 'write'
  | 'approve'
  | 'release'
  | 'admin'
  | 'custom_rule_admin'
  | 'cohort_admin'
  | 'routing_plan_admin'
  | 'team_admin'
  | 'campaign_template_admin';

interface ITeamMembersResponse {
  [team: string]: {
    [r in Role]: CognitoUser[];
  };
}

export default function useFetchTeamMembers() {
  return useQuery({
    queryKey: ['teamMembers'],
    queryFn: async (): Promise<ITeamMembersResponse | null> => {
      const authSession = await fetchAuthSession();
      if (!authSession) {
        return null;
      }

      try {
        const teamMembers = await apiFetch<ITeamMembersResponse>({
          path: 'team/users',
          method: 'GET',
          accessToken: authSession.tokens?.accessToken.toString() || '',
        });

        if (!teamMembers) {
          return null;
        }

        return teamMembers;
      } catch {
        return null;
      }
    },
    enabled: true,
  });
}
